import { Route } from '@angular/router';
import { AdminComponent } from '@c/admin/admin.component';

export const outletAdmin = (options: Route = {}): Route => {
    return Object.assign({
        component: AdminComponent,
        outlet: "admin",
    }, options);
};
